// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductHeader_container__2_aOu","backLinkContainer":"ProductHeader_backLinkContainer__3ErV4","breadcrumbs":"ProductHeader_breadcrumbs__1aTdW"};